module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoAdministraciones-6ef27907ec4959ffb8c5b8921a5c7407.png";